import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
// TODO Make this more generic
import quickNotesPopupStayActivePredicate from '../../header/workspaceToolsHeader/quickNotes/popup/quickNotesPopupStayActivePredicate';

// Selectors
import popupOpenSelector from '../../../components/popupPanel/popupOpenSelector';

// Components
import Tool from '../components/Tool';
import Icon from '../../../components/icons/Icon';
import PopupTrigger from '../../../components/popupPanel/PopupTrigger';
import TrashPopup from './popup/TrashPopup';

// Decorators
import trashDropTargetDecorator from './trashDropTargetDecorator';
import renderListPlaceholdersDecorator from '../../../element/elementPlaceholder/renderListPlaceholdersDecorator';

// Actions
import { deselectAllElements } from '../../../element/selection/selectionActions';

// Context
import { zoomStateContextConsumer } from '../../../canvas/zoom/ZoomStateContext';

// Constants
import { PopupIds } from '../../../components/popupPanel/popupConstants';

// Styles
import './Trash.scss';

const mapStateToProps = createStructuredSelector({
    trashPopupOpen: popupOpenSelector(PopupIds.TRASH),
});

const mapDispatchToProps = (dispatch) => ({
    deselectAllElements: () => dispatch(deselectAllElements()),
});

@connect(mapStateToProps, mapDispatchToProps)
@zoomStateContextConsumer
@trashDropTargetDecorator
@renderListPlaceholdersDecorator
class Trash extends React.Component {
    render() {
        const {
            isHovered,
            connectDropTarget,
            trashPopupOpen,
            currentBoardId,
            getInitialElementsVisibility,
            saveElementRenderState,
            elementPlaceholderMeasurements,
            allowElementPlaceholder,
        } = this.props;

        return (
            <div
                ref={connectDropTarget}
                className={classNames('Trash', { hover: isHovered, 'popup-open': trashPopupOpen })}
                id="trash"
            >
                <PopupTrigger popupId={PopupIds.TRASH} stayActivePredicate={quickNotesPopupStayActivePredicate}>
                    {() => (
                        <Tool {...this.props} name="Trash" isDragging={false}>
                            <Icon {...this.props} name="toolbar-trash-empty" />
                        </Tool>
                    )}
                </PopupTrigger>
                <TrashPopup
                    currentBoardId={currentBoardId}
                    saveElementRenderState={saveElementRenderState}
                    elementPlaceholderMeasurements={elementPlaceholderMeasurements}
                    getInitialElementsVisibility={getInitialElementsVisibility}
                    allowElementPlaceholder={allowElementPlaceholder}
                />
            </div>
        );
    }
}

Trash.propTypes = {
    connectDropTarget: PropTypes.func,
    deselectAllElements: PropTypes.func,
    isHovered: PropTypes.bool,
    currentBoardId: PropTypes.string,
    trashPopupOpen: PropTypes.bool,
    getInitialElementsVisibility: PropTypes.func,
    saveElementRenderState: PropTypes.func,
    elementPlaceholderMeasurements: PropTypes.object,
    allowElementPlaceholder: PropTypes.bool,
};

export default Trash;
